package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Papua New Guinea Flag (16x12dp)
 *
 * - ISO Alpha-2: PG
 * - ISO Alpha-3: PNG
 * - ISO Numeric: 598
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.PapuaNewGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Papua New Guinea:PG:PNG:598:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE11C1B))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1D1D1D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(16f, 12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.542f, 9.134f)
                horizontalLineTo(4.208f)
                lineTo(4.524f, 8.388f)
                lineTo(4.897f, 9.129f)
                lineTo(5.579f, 9.167f)
                lineTo(4.996f, 9.801f)
                lineTo(5.295f, 10.566f)
                lineTo(4.554f, 10.14f)
                lineTo(3.87f, 10.569f)
                lineTo(4.128f, 9.827f)
                lineTo(3.542f, 9.134f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(1.542f, 7.134f)
                horizontalLineTo(2.208f)
                lineTo(2.524f, 6.388f)
                lineTo(2.897f, 7.129f)
                lineTo(3.579f, 7.167f)
                lineTo(2.996f, 7.801f)
                lineTo(3.295f, 8.566f)
                lineTo(2.554f, 8.14f)
                lineTo(1.87f, 8.569f)
                lineTo(2.128f, 7.827f)
                lineTo(1.542f, 7.134f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.542f, 6.134f)
                horizontalLineTo(4.208f)
                lineTo(4.524f, 5.388f)
                lineTo(4.897f, 6.129f)
                lineTo(5.579f, 6.167f)
                lineTo(4.996f, 6.801f)
                lineTo(5.295f, 7.566f)
                lineTo(4.554f, 7.14f)
                lineTo(3.87f, 7.569f)
                lineTo(4.128f, 6.827f)
                lineTo(3.542f, 6.134f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.856f, 8.282f)
                lineTo(5.313f, 8.267f)
                lineTo(5.479f, 7.795f)
                lineTo(5.664f, 8.264f)
                lineTo(6.085f, 8.305f)
                lineTo(5.706f, 8.573f)
                lineTo(6.012f, 9.048f)
                lineTo(5.481f, 8.849f)
                lineTo(5.021f, 9.054f)
                lineTo(5.264f, 8.586f)
                lineTo(4.856f, 8.282f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFEEEEF6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.856f, 7.282f)
                lineTo(6.313f, 7.267f)
                lineTo(6.479f, 6.795f)
                lineTo(6.664f, 7.264f)
                lineTo(7.085f, 7.305f)
                lineTo(6.706f, 7.573f)
                lineTo(7.012f, 8.048f)
                lineTo(6.481f, 7.849f)
                lineTo(6.021f, 8.054f)
                lineTo(6.264f, 7.586f)
                lineTo(5.856f, 7.282f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.542f, 1f)
                curveTo(10.542f, 1f, 8.998f, 1.308f, 9.431f, 3.455f)
                horizontalLineTo(9.211f)
                curveTo(9.211f, 3.455f, 9.229f, 3.343f, 9.017f, 3.277f)
                curveTo(8.805f, 3.212f, 8.847f, 3.236f, 8.738f, 3.277f)
                curveTo(8.629f, 3.318f, 7.964f, 3.277f, 7.964f, 3.277f)
                verticalLineTo(3.359f)
                lineTo(8.434f, 3.563f)
                curveTo(8.434f, 3.563f, 8.423f, 3.732f, 8.62f, 3.826f)
                curveTo(8.816f, 3.919f, 8.959f, 3.965f, 8.959f, 3.965f)
                curveTo(8.959f, 3.965f, 8.988f, 4.151f, 8.804f, 4.151f)
                curveTo(8.62f, 4.151f, 7.878f, 3.911f, 7.614f, 4.502f)
                curveTo(7.351f, 5.092f, 7f, 5.525f, 7f, 5.525f)
                horizontalLineTo(7.395f)
                lineTo(7.289f, 5.657f)
                horizontalLineTo(7.735f)
                lineTo(7.614f, 5.726f)
                curveTo(7.614f, 5.726f, 8.165f, 5.72f, 8.208f, 5.657f)
                curveTo(8.251f, 5.595f, 8.208f, 5.826f, 8.208f, 5.826f)
                curveTo(8.208f, 5.826f, 8.742f, 5.582f, 8.771f, 5.525f)
                lineTo(9.02f, 5.696f)
                lineTo(9.091f, 5.407f)
                lineTo(9.358f, 5.525f)
                lineTo(9.431f, 5.25f)
                curveTo(9.431f, 5.25f, 10.187f, 6.514f, 10.76f, 6.442f)
                verticalLineTo(6.232f)
                lineTo(11.284f, 6.442f)
                lineTo(11.35f, 6.348f)
                curveTo(11.35f, 6.348f, 11.982f, 6.606f, 12.177f, 6.63f)
                lineTo(12.038f, 6.348f)
                horizontalLineTo(12.177f)
                lineTo(12.038f, 5.826f)
                horizontalLineTo(12.177f)
                lineTo(11.899f, 5.407f)
                lineTo(11.977f, 5.294f)
                lineTo(11.926f, 5.145f)
                curveTo(11.926f, 5.145f, 12.943f, 5.469f, 12.897f, 5.985f)
                curveTo(12.851f, 6.501f, 12.398f, 6.709f, 12.398f, 6.709f)
                curveTo(12.398f, 6.709f, 11.964f, 6.842f, 11.571f, 6.813f)
                curveTo(11.571f, 6.813f, 11.883f, 7.181f, 12.542f, 7.057f)
                curveTo(13.201f, 6.932f, 13.42f, 6.293f, 13.42f, 6.293f)
                curveTo(13.42f, 6.293f, 13.722f, 6.921f, 13.474f, 7.251f)
                curveTo(13.224f, 7.581f, 12.116f, 7.813f, 12.116f, 7.813f)
                curveTo(12.116f, 7.813f, 12.517f, 8.048f, 12.897f, 7.988f)
                curveTo(13.278f, 7.927f, 13.869f, 7.597f, 13.983f, 7.057f)
                curveTo(14.098f, 6.517f, 13.588f, 5.521f, 13.357f, 5.407f)
                lineTo(13.266f, 5.062f)
                lineTo(13.474f, 5.145f)
                lineTo(13.047f, 4.103f)
                lineTo(13.254f, 4.148f)
                lineTo(12.651f, 3.398f)
                lineTo(12.817f, 3.347f)
                lineTo(11.984f, 2.748f)
                lineTo(12.233f, 2.682f)
                curveTo(12.233f, 2.682f, 11.617f, 2.37f, 10.915f, 2.748f)
                lineTo(10.922f, 2.617f)
                lineTo(10.737f, 2.648f)
                lineTo(10.748f, 2.505f)
                lineTo(10.932f, 2.227f)
                lineTo(10.656f, 2.121f)
                curveTo(10.656f, 2.121f, 10.879f, 1.786f, 10.845f, 1.791f)
                curveTo(10.845f, 1.791f, 10.597f, 1.862f, 10.611f, 1.832f)
                curveTo(10.611f, 1.832f, 10.736f, 1.51f, 10.703f, 1.519f)
                curveTo(10.703f, 1.519f, 10.416f, 1.616f, 10.458f, 1.567f)
                lineTo(10.569f, 1.371f)
                lineTo(10.542f, 1f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun PapuaNewGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.PapuaNewGuinea,
            contentDescription = "Papua New Guinea Flag"
        )
    }
}
